// extracted by mini-css-extract-plugin
export default {"container":"EV-z","title":"FV-z","link":"GV-z"};